import { Typography } from "@mui/material";
import NoteHistoryWrapper from "components/summary/success-plan/components/sections/NoteHistoryWrapper";
import moment from "moment";
import styles from "../SuccessPlan.module.scss";

type NoteWrapperProps = {
  riskNote: string | null;
  noteHistories: any[];
  lastUpdatedOn?: string;
};

const NoteWrapper = ({ riskNote, noteHistories, lastUpdatedOn = "N/A" }: NoteWrapperProps) => {
  return (
    <>
      <div className={`${styles["sp-horizontal-space"]} ${styles["sp-label-gray"]}`}>
        <Typography>Summary Notes and Asks:</Typography>
        {
          <div className={`${styles["sp-flex-horizontal"]} }`}>
            <div className={styles["sp-label-gray"]}>Last Updated On: </div>
            <div className={styles["sp-label"]}>{lastUpdatedOn}</div>
          </div>
        }
      </div>

      <div
        dangerouslySetInnerHTML={{
          __html: riskNote ?? "",
        }}
        style={{
          height: 200,
          border: "1px solid #ddd",
          borderRadius: 8,
          overflowY: "auto",
          padding: 14,
        }}
      ></div>
      <NoteHistoryWrapper noteHistories={noteHistories} />
    </>
  );
};

export default NoteWrapper;
